exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rule-input[data-v-6a93fc0f]  .el-input__inner{border:0}\n", ""]);

// exports
